var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import AuthConstants from '../../constants/Auth.constants';
import LocalStorageService from './../../utils/LocalStorageService';
import { defaultstats } from '../../common/stats';
import api from './../../utils/AuthAPI';
var initialDataAuth = {
    email: '',
    password: '',
    login: '',
};
var useAuthContext = function () {
    var _a = useState({ isAuth: false }), userState = _a[0], setUserState = _a[1];
    var _b = useState(initialDataAuth), dataAuth = _b[0], setDataAuth = _b[1];
    var _c = useState(''), err = _c[0], setErr = _c[1];
    var _d = useState(false), isGreeting = _d[0], setGreeting = _d[1];
    var _e = useState(false), isParting = _e[0], setParting = _e[1];
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    var _g = useState(false), isAuth = _g[0], setAuth = _g[1];
    var _h = useState(false), openLogin = _h[0], setOpenLogin = _h[1];
    var _j = useState(false), preloader = _j[0], setPreloader = _j[1];
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    var handleOpenLogin = function () { return setOpenLogin(true); };
    var handleCloseLogin = function () { return setOpenLogin(false); };
    var unAuthorization = function () {
        setUserState({ isAuth: false });
        setParting(true);
        setTimeout(function () { return setParting(false); }, AuthConstants.POP_UP_DELAY);
        window.location.reload();
        LocalStorageService.clear();
    };
    var handleDataFields = function (e) {
        var target = e.target;
        if (target.type === 'email') {
            setDataAuth(__assign(__assign({}, dataAuth), { email: target.value.trim() }));
        }
        if (target.type === 'password') {
            setDataAuth(__assign(__assign({}, dataAuth), { password: target.value.trim() }));
        }
        if (target.type === 'text') {
            setDataAuth(__assign(__assign({}, dataAuth), { login: target.value.trim() }));
        }
    };
    var validateEmail = function (email) {
        return String(email)
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };
    var handlerSubmit = function (evt) {
        evt.preventDefault();
    };
    var createUser = function () {
        var email = dataAuth.email, password = dataAuth.password, login = dataAuth.login;
        if (!validateEmail(email)) {
            setErr(AuthConstants.ERROR_EMAIL);
            setPreloader(false);
            return;
        }
        if (password.length < 8) {
            setErr(AuthConstants.ERROR_PASS);
            setPreloader(false);
            return;
        }
        if (!login) {
            setErr(AuthConstants.ERROR_LOGIN);
            setPreloader(false);
            return;
        }
        setPreloader(true);
        var newUser = { email: email, password: password, name: login };
        api.createUser(newUser).then(function (response) {
            if (response && response.status === 417) {
                setErr(AuthConstants.ERROR_CREATE);
                setPreloader(false);
            }
            else {
                setErr('');
                setGreeting(true);
                setTimeout(function () {
                    setGreeting(false);
                    setOpen(false);
                    setPreloader(false);
                    setOpenLogin(true);
                    api.loginUser({ email: email, password: password, login: login }).then(function (resp) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, userId_1, token_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(resp && resp.ok)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, resp.json()];
                                case 1:
                                    _a = _b.sent(), userId_1 = _a.userId, token_1 = _a.token;
                                    api
                                        .getStat(userId_1, token_1)
                                        .then(function (resp) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            if (resp && resp.status === 404) {
                                                api.updateStat(userId_1, token_1, defaultstats);
                                            }
                                            return [2 /*return*/];
                                        });
                                    }); });
                                    _b.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                }, AuthConstants.POP_UP_DELAY);
            }
        });
    };
    var logInUser = function () {
        var email = dataAuth.email, password = dataAuth.password, login = dataAuth.login;
        if (!validateEmail(email)) {
            setErr(AuthConstants.ERROR_EMAIL);
            return;
        }
        if (password.length < 8) {
            setErr(AuthConstants.ERROR_PASS);
            return;
        }
        setPreloader(true);
        api.loginUser({ email: email, password: password, login: login }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var body, token, refreshToken, userId, name_1, userInfo, experience;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (response && response.status === 404) {
                            setErr(AuthConstants.ERROR_AUTH);
                            setPreloader(false);
                        }
                        if (response && response.status === 403) {
                            setErr(AuthConstants.ERROR_SIGIN);
                            setPreloader(false);
                        }
                        if (!(response && response.status === 200)) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.json()];
                    case 1:
                        body = (_a.sent());
                        token = body.token, refreshToken = body.refreshToken, userId = body.userId, name_1 = body.name;
                        userInfo = { token: token, refreshToken: refreshToken, userId: userId, name: name_1 };
                        experience = new Date();
                        setUserState({ isAuth: true });
                        setAuth(true);
                        LocalStorageService.setItem(AuthConstants.USER_KEY_STORAGE, __assign(__assign({}, userInfo), { isAuth: true, name: name_1, experience: experience }));
                        setDataAuth(initialDataAuth);
                        setPreloader(false);
                        setOpenLogin(false);
                        setGreeting(true);
                        setTimeout(function () {
                            setAuth(false);
                            setGreeting(false);
                            window.location.reload();
                        }, AuthConstants.POP_UP_DELAY);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    var notifyAuthFalse = function () {
        var userInfo = LocalStorageService.getItem(AuthConstants.USER_KEY_STORAGE);
        setErr(AuthConstants.ERROR_TOKEN_MISS);
        setAuth(false);
        LocalStorageService.setItem(AuthConstants.USER_KEY_STORAGE, __assign(__assign({}, userInfo), { isAuth: false }));
        handleOpenLogin();
    };
    var setDBUSer = function () {
        if (err === '') {
            setOpen(false);
        }
    };
    return {
        dataAuth: dataAuth,
        userState: userState,
        err: err,
        isGreeting: isGreeting,
        isParting: isParting,
        open: open,
        isAuth: isAuth,
        openLogin: openLogin,
        handleOpen: handleOpen,
        handleClose: handleClose,
        unAuthorization: unAuthorization,
        handlerSubmit: handlerSubmit,
        handleDataFields: handleDataFields,
        createUser: createUser,
        setDBUSer: setDBUSer,
        handleOpenLogin: handleOpenLogin,
        handleCloseLogin: handleCloseLogin,
        logInUser: logInUser,
        preloader: preloader,
        notifyAuthFalse: notifyAuthFalse,
    };
};
export default useAuthContext;
